import { JSX, useContext } from "react";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { NetworkSubmissionProject } from "@app/compliance-connect/network-submission/interfaces";
import { NetworkSubmissionContext } from "@app/compliance-connect/network-submission/NetworkSubmissionContext";
import { NetworkSubmissionWizardAction } from "@app/compliance-connect/network-submission/networkSubmissionWizardActions";

interface ProjectRadioButtonProps {
  project: NetworkSubmissionProject;
}

function ProjectRadioButton({ project }: ProjectRadioButtonProps): JSX.Element {
  const context = useContext(NetworkSubmissionContext);

  return (
    <QESRadioButton
      checked={project.id === context.selectedProject?.id}
      label=""
      name={`ns-project-select-${project.id}`}
      testId={`ns-project-select-${project.id}`}
      onChange={() => context.dispatch({ payload: project, type: NetworkSubmissionWizardAction.SelectProject })}
    />
  );
}

export default ProjectRadioButton;
